[].slice.call(document.querySelectorAll('.stat')).forEach(function(stat) {
	var statisticsAnimation = new Waypoint({
		element: stat,
		handler: function(direction) {
			animateCountUp(stat);

			this.destroy();
		},
		offset: '85%'
	});
});

// How long you want the animation to take, in ms
const animationDuration = 1500;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round(animationDuration / frameDuration);
// An ease-out function that slows the count as it progresses
const easeOutQuad = t => t * (2 - t);

// The animation function, which takes an Element
const animateCountUp = el => {
	let frame = 0;
	let num = el.querySelector('.number span:first-child');
	let numValue = num.innerHTML;

	const countTo = parseFloat(numValue);
	// Start the animation running 60 times per second
	const counter = setInterval(() => {
		frame++;
		// Calculate our progress as a value between 0 and 1
		// Pass that value to our easing function to get our
		// progress on a curve
		const progress = easeOutQuad(frame / totalFrames);
		// Use the progress value to calculate the current count
		const currentCount = (countTo * progress).toFixed(countTo % 1 ? numValue.split('.')[1].length : 0);

		// If the current count has changed, update the element
		if(parseInt(numValue, 10) !== currentCount)
			num.innerHTML = currentCount;

		// If we’ve reached our last frame, stop the animation
		if(frame === totalFrames) {
			clearInterval(counter);
			el.classList.add('done');
		}
	}, frameDuration);
};